/**
 *  Alaska: Editor
 *  Public: Risk Calculator questionnare
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('RiskDDoSCalculator', () => ({
        started: false,
        completed: false,
        showScore: false,
        currentQuestion: 0,
        currentHelperText: null,
        answeredCount: 1,
        openedAnswersImprove: {},
        openedAnswersStrong: {},
        savedResultId: null,

        questions: [
            {
                text: 'How important is the internet to your business being able to operate properly?',
                options: [
                    { label: 'Critical', score: 1 },
                    { label: 'Very Important', score: 2 },
                    { label: 'Somewhat important', score: 3 },
                    { label: 'Not important', score: 4 },
                ],
                helperText: 'Businesses increasingly  rely on internet connectivity to operate every part of their organisation.  Without, business stops, producitivty stops and customers get frustrated and could go elsewhere.',
                answer: null,
            },
            {
                text: 'If you suffered an internet outage, how long could you manage before it because a business-critical issue',
                options: [
                    { label: '10 minutes', score: 1 },
                    { label: '30 minutes', score: 2 },
                    { label: '1 hour', score: 3 },
                    { label: '4 hours ', score: 4 },
                ],
                helperText:
                    '',
                answer: null,
            },
            {
                text: 'If your business was hit with a DDOS attack, would you be concerned about reputational damage?',
                options: [
                    { label: 'Very concerned', score: 1 },
                    { label: 'Concerned', score: 2 },
                    { label: 'Somewhat concerned', score: 3 },
                    { label: 'Not concerned', score: 4 },
                ],
                helperText:
                    '',
                answer: null,
            },
            {
                text: 'Do you have regulatory or compliance requirements, such as PCI-DSS that require you to maintain a certain uptime?',
                options: [
                    { label: 'Yes', score: 1 },
                    { label: 'No', score: 2 },
                ],
                helperText:
                    '',
                answer: null,
            },
            {
                text: 'What is your biggest security concern',
                options: [
                    { label: "Not knowing if we're up to date and compliant", score: 2 },
                    { label: 'The potential for business interruption', score: 2 },
                    { label: 'People in our business clicking on things and exposing us to risk, such as ransomware', score: 2 },
                    { label: "Nothing, we're happy we've got everything in place.", score: 4 },
                ],
                helperText:
                    'Businesses see key risks as human considerations, such as phishing and social engineering attacks.  With increasing number of threats, businesses need to ensure they have robust processes in place to manage cyber security effectively, and to assure themselves that all appropriate steps have been taken.  A regular risk analysis will highlight areas of concern to focus on.',
                answer: null,
            },
        ],

        get maxScore() {
            return this.questions.reduce((sum, q) => sum + Math.max(...q.options.map((o) => o.score)), 0);
        },

        get scoreBreakdown() {
            return this.questions.map((q, index) => {
                const maxQuestionScore = Math.max(...q.options.map((o) => o.score));
                const userScore = q.answer?.score || 0;
                const percentage = userScore / maxQuestionScore;

                return {
                    number: index + 1,
                    text: q.text,
                    userScore,
                    maxQuestionScore,
                    percentage,
                    answer: q.answer?.label || null,
                };
            });
        },

        get areasToImprove() {
            return this.scoreBreakdown
                .filter((item) => item.percentage > 0.25 && item.percentage < 0.75)
                .map((item) => {
                    this.openedAnswersImprove[item.number] = true;
                    return item;
                });
        },

        get strongAreas() {
            return this.scoreBreakdown
                .filter((item) => item.percentage >= 0.75)
                .map((item) => {
                    this.openedAnswersStrong[item.number] = true;
                    return item;
                });
        },

        get totalUserScore() {
            return this.questions.reduce((sum, q) => sum + (q.answer?.score || 0), 0);
        },

        get progress() {
            return this.totalUserScore / this.maxScore;
        },

        get lineLength() {
            return 381.14;
        },

        get lineOffset() {
            return this.lineLength * (1 - this.progress);
        },

        get riskLevel() {
            const percentage = this.totalUserScore / this.maxScore;
            if (percentage <= 0.25) return { label: 'High Risk', bg: 'bg-risk-high-bg', text: 'text-risk-high' };
            if (percentage < 0.75) return { label: 'Moderate Risk', bg: 'bg-risk-medium-bg', text: 'text-risk-medium' };
            return { label: 'Low Risk', bg: 'bg-risk-low-bg', text: 'text-risk-low' };
        },

        get isAttentionNeeded() {
            return this.riskLevel.label !== 'Low Risk';
        },

        get isOptionSelected() {
            return this.questions[this.currentQuestion].answer !== null;
        },

        showAnsweredImprove(index) {
            this.openedAnswersImprove[index] = !this.openedAnswersImprove[index];
        },

        showAnsweredStrong(index) {
            this.openedAnswersStrong[index] = !this.openedAnswersStrong[index];
        },

        getColor() {
            if (this.progress <= 0.25) return 'text-risk-high'; // red
            if (this.progress < 0.75) return 'text-risk-medium'; // yellow
            return 'text-risk-low'; // green
        },

        getProgressBarColor(percentage) {
            if (percentage <= 0.25) return 'bg-risk-high'; // red
            if (percentage < 0.75) return 'bg-risk-medium'; // yellow
            return 'bg-risk-low'; // green
        },

        startAssessment() {
            this.started = true;
            this.completed = false;
        },

        toggleHelperText() {
            if (this.currentHelperText === this.questions[this.currentQuestion].helperText) {
                this.currentHelperText = null;
            } else {
                this.currentHelperText = this.questions[this.currentQuestion].helperText;
            }
        },

        selectOption(option) {
            this.questions[this.currentQuestion].answer = option;
        },

        async nextQuestion() {
            if (!this.isOptionSelected) return;
            if (this.currentQuestion < this.questions.length - 1) {
                this.currentQuestion++;
                this.answeredCount++;
                this.currentHelperText = null;
            } else if (this.answeredCount === this.questions.length) {
                this.completed = true;

                const result = await this.saveRiskAssessment();

                if (!result) return;

                setTimeout(() => {
                    this.completed = false;
                    this.showScore = true;
                }, 1000);
            }
        },

        previousQuestion() {
            if (this.currentQuestion > 0) {
                this.currentQuestion--;
                this.answeredCount--;
                this.currentHelperText = null;
            } else {
                this.started = false;
            }
        },

        async saveRiskAssessment() {
            try {
                const res = await fetch('/alaska/public/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        controller: 'Marketing',
                        action: 'saveRiskAssessment',
                        data: {
                            totalUserScore: this.totalUserScore,
                            percentage: this.progress,
                            breakdown: this.questions.map((q, index) => ({
                                questionId: index + 1,
                                question: q.text,
                                answer: q.answer?.label,
                                score: q.answer?.score || 0,
                            })),
                        },
                    }),
                });

                const result = await res.json();

                if (result.type === 'error') {
                    Notification.render(result.message, 'error');
                }

                this.savedResultId = result.id;

                return result;
            } catch (error) {
                console.error(error);
            }
        },

        openContactUsModal() {
            const store = Alpine.store('HtmlModal');
            store.load_html({
                controller: 'Menu',
                action: 'fetch',
                data: {
                    icon: 'fa-user',
                    title: 'Speak to a Security Expert',
                    menu: 'risk_calculator_form',
                },
                payload: { resultId: this.savedResultId },
                callback: (status) => {
                    console.log('Assessment flow complete');
                },
            });
        },
    }));
});
